import { ForgotCompanyCredentials } from '@pages/login-recovery-options/models/forgot-company-credentials.interface';
import { ForgotPasswordCredentials } from '@pages/login-recovery-options/models/forgot-password-credentials.interface';
import { ForgotUsernameCredentials } from '@pages/login-recovery-options/models/forgot-username-credentials.interface';

const actionScope = '[Login Recovery]';

export class RecoverCredentialsByUsername {
  static readonly type = `${actionScope} Recover Credentials By Username`;

  constructor(public recoverUsernameCredentials: ForgotUsernameCredentials) {}
}

export class RecoverCredentialsByCompany {
  static readonly type = `${actionScope} Recover Credentials By Company`;

  constructor(public recoverCompanyCredentials: ForgotCompanyCredentials) {}
}

export class RecoverCredentialsByPassword {
  static readonly type = `${actionScope} Recover Credentials By Password`;

  constructor(public recoverPasswordCredentials: ForgotPasswordCredentials) {}
}
